// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_OrganisationUpdateModel from '../../model/tdg-organisation-update-model';
import Tdg_OrganisationUpdateDTO from '../dto/tdg-organisation-update-dto';
import dtoSchema from '../schemas/tdg-organisation-update-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class Tdg_OrganisationUpdateModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_OrganisationUpdateDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.externalId = data.externalId;
      this.organisationName = data.organisationName;
      this.logoDocumentId = data.logoDocumentId ?? undefined;
      this.membersCount = data.membersCount;
      this.organisationContactSalutation = data.organisationContactSalutation;
      this.organisationContactFirstName = data.organisationContactFirstName;
      this.organisationContactLastName = data.organisationContactLastName;
      this.organisationContactPhoneNumber = data.organisationContactPhoneNumber;
      this.organisationContactEmail = data.organisationContactEmail;
      this.organisationStreet = data.organisationStreet;
      this.organisationHouseNumber = data.organisationHouseNumber ?? undefined;
      this.organisationZIP = data.organisationZIP;
      this.organisationCity = data.organisationCity;
      this.acceptConditions = data.acceptConditions;
      this.organisationUserId = data.organisationUserId ?? undefined;
      this.isSupporter = data.isSupporter;
      this.logoDocumentExternalId = data.logoDocumentExternalId ?? undefined;
      this.userName = data.userName ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {uuid}
  */
  externalId?: string;
  /**
  * @minimum 1
  */
  organisationName?: string;
  /**
  * @type {int64}
  */
  logoDocumentId?: number;
  /**
  * @type {int32}
  */
  membersCount?: number;
  /**
  * @type {int32}
  */
  organisationContactSalutation?: 0 | 1 | 2; // SalutationDTO
  /**
  * @minimum 1
  */
  organisationContactFirstName?: string;
  /**
  * @minimum 1
  */
  organisationContactLastName?: string;
  /**
  * @minimum 1
  */
  organisationContactPhoneNumber?: string;
  /**
  * @minimum 1
  */
  organisationContactEmail?: string;
  /**
  * @minimum 1
  */
  organisationStreet?: string;
  /**
  */
  organisationHouseNumber?: string;
  /**
  * @minimum 1
  */
  organisationZIP?: string;
  /**
  * @minimum 1
  */
  organisationCity?: string;
  /**
  */
  acceptConditions?: boolean;
  /**
  * @type {int64}
  */
  organisationUserId?: number;
  /**
  */
  isSupporter?: boolean;
  /**
  */
  logoDocumentExternalId?: string;
  /**
  */
  userName?: string;

  static toModel(dto: DeepPartial<Tdg_OrganisationUpdateDTO>): Tdg_OrganisationUpdateModel;
  static toModel(dto: DeepPartial<Tdg_OrganisationUpdateDTO> | undefined | null): Tdg_OrganisationUpdateModel | undefined;
  static toModel(dto: DeepPartial<Tdg_OrganisationUpdateDTO> | undefined | null): Tdg_OrganisationUpdateModel | undefined {
    return dto ? new Tdg_OrganisationUpdateModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_OrganisationUpdateModel> | Tdg_OrganisationUpdateModel): Tdg_OrganisationUpdateDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      externalId: unwrapped.externalId,
      organisationName: unwrapped.organisationName,
      logoDocumentId: unwrapped.logoDocumentId,
      membersCount: unwrapped.membersCount,
      organisationContactSalutation: unwrapped.organisationContactSalutation,
      organisationContactFirstName: unwrapped.organisationContactFirstName,
      organisationContactLastName: unwrapped.organisationContactLastName,
      organisationContactPhoneNumber: unwrapped.organisationContactPhoneNumber,
      organisationContactEmail: unwrapped.organisationContactEmail,
      organisationStreet: unwrapped.organisationStreet,
      organisationHouseNumber: unwrapped.organisationHouseNumber,
      organisationZIP: unwrapped.organisationZIP,
      organisationCity: unwrapped.organisationCity,
      acceptConditions: unwrapped.acceptConditions,
      organisationUserId: unwrapped.organisationUserId,
      isSupporter: unwrapped.isSupporter,
      logoDocumentExternalId: unwrapped.logoDocumentExternalId,
      userName: unwrapped.userName,
    } as Tdg_OrganisationUpdateDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_OrganisationUpdateModel, can not map to Tdg_OrganisationUpdateDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
